import { FieldValues } from 'react-hook-form';

export const getCountFilledFields = (values: FieldValues) =>
  Object.values(values).filter(element => element !== undefined).length;
